<template>
  <div>
    <a-form-item :label="$t('scope.text_26')">
      <a-input v-decorator="decorators.name" :placeholder="$t('scope.text_26')" />
    </a-form-item>
    <a-form-item :label="$t('scope.text_27')">
      <a-radio-group v-decorator="decorators.os_type">
        <a-radio-button v-for="(v, k) in $t('osTypes')" :value="k" :key="k">{{v}}</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item :label="$t('scope.text_28')">
      <a-input v-decorator="decorators.os_distribution" :placeholder="$t('scope.text_29')" />
    </a-form-item>
    <a-form-item :label="$t('scope.text_30')">
      <a-input v-decorator="decorators.os_version" :placeholder="$t('scope.text_31')" />
    </a-form-item>
    <a-form-item :label="$t('scope.text_32')">
      <a-radio-group v-decorator="decorators.os_arch">
        <a-radio-button v-for="(v, k) in $t('archTypes')" :value="k" :key="k">{{v}}</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item :label="$t('scope.text_33')">
      <a-radio-group v-model="uploadType">
        <a-radio-button v-for="(v, k) in $t('isoUploadTypes')" :value="k" :key="k">{{v}}</a-radio-button>
      </a-radio-group>
    </a-form-item>
    <a-form-item :label="$t('scope.text_34')" v-if="uploadType === 'file'">
      <a-upload
        @change="handleUploadChange"
        :fileList="fileList"
        :beforeUpload="beforeUpload">
        <a-button> <a-icon type="upload" />{{$t('scope.text_35')}}</a-button>
      </a-upload>
    </a-form-item>
    <a-form-item :label="$t('scope.text_36')" v-if="uploadType === 'url'">
      <a-input :placeholder="$t('scope.text_37')" v-decorator="decorators.copy_from" />
    </a-form-item>
  </div>
</template>

<script>
export default {
  name: 'ISOUpload',
  data () {
    return {
      uploadType: 'file',
      fileList: [],
      decorators: {
        name: [
          'name',
          {
            validateFirst: true,
            rules: [
              { required: true, message: this.$t('scope.text_38') },
              // { validator: this.$validate('resourceName') },
            ],
          },
        ],
        os_type: [
          'os_type',
          {
            initialValue: 'Linux',
          },
        ],
        os_distribution: [
          'os_distribution',
        ],
        os_version: [
          'os_version',
        ],
        os_arch: [
          'os_arch',
          {
            initialValue: '',
          },
        ],
        copy_from: [
          'copy_from',
          {
            validateFirst: true,
            rules: [
              { required: true, message: this.$t('scope.text_37') },
              { validator: this.validateUrl },
            ],
          },
        ],
      },
    }
  },
  methods: {
    validateUrl (rule, value, callback) {
      if (value && (value.startsWith('http://') || value.startsWith('https://'))) {
        callback()
      } else {
        callback(new Error(this.$t('scope.text_39')))
      }
    },
    beforeUpload (file) {
      this.fileList = [file]
      return false
    },
    handleUploadChange ({ file, fileList }) {
      this.fileList = [file]
    },
    async postFile (values) {
      const file = this.fileList[0]
      const allData = {
        name: values.name,
        os_type: values.os_type,
        os_distribution: values.os_distribution,
        os_version: values.os_version,
        os_arch: values.os_arch,
        image_size: file.size,
        image: file,
      }
      const fd = new FormData()
      for (const key in allData) {
        if (allData[key]) {
          fd.append(key, allData[key])
        }
      }
      await this.$http({
        url: '/v1/imageutils/upload',
        method: 'post',
        processData: false,
        data: fd,
        timeout: 0,
      })
    },
    async postUrl (data) {
      const params = {
        copy_from: data.copy_from,
        name: data.name,
        properties: {
          os_type: data.os_type,
          os_version: '',
        },
      }
      const manager = new this.$Manager('images', 'v1')
      await manager.create({
        data: params,
      })
    },
    async doSubmit (fc) {
      if (this.uploadType === 'file' && (!this.fileList || !this.fileList.length)) {
        this.$message.error(this.$t('scope.text_40'))
        return false
      }
      try {
        const values = await fc.validateFields(['name', 'os_type', 'os_distribution', 'os_version', 'image_size', 'image', 'os_arch', 'copy_from'])
        if (this.uploadType === 'file') {
          await this.postFile(values)
        } else {
          await this.postUrl(values)
        }
      } catch (err) {
        throw err
      }
    },
  },
}
</script>
